import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaMobileAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Hero = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleContactClick = () => {
		navigate("/contact-us");
	};

	const contactItems = [
		{ icon: FaPhone, label: t("landlinePhone"), value: "22410 43755" },
		{ icon: FaMobileAlt, label: t("mobilePhone"), value: "+30 695 129 0680" },
		{ icon: FaEnvelope, label: t("email"), value: "premtisk@gmail.com" },
		{ icon: FaMapMarkerAlt, label: t("adress"), value: `${t("street")} 49, ${t("city")}, 85132` },
	];

	return (
		<section
			className="relative min-h-[85vh] bg-cover bg-center bg-fixed flex items-center overflow-hidden"
			style={{
				backgroundImage:
					"url(https://res.cloudinary.com/dmwvkjqsn/image/upload/v1718632746/AccountingBusinessCDN/c9euehjdrnbtrhyayppu.webp)",
			}}
		>
			{/* Gradient overlay */}
			<div className="absolute inset-0 bg-gradient-to-br from-slate-900/85 via-slate-800/60 to-slate-900/80"></div>

			{/* Decorative elements */}
			<div className="absolute top-20 left-10 w-72 h-72 bg-accent/20 rounded-full blur-3xl animate-pulse-slow"></div>
			<div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-pulse-slow animate-delay-300"></div>

			<div className="container relative z-10">
				<div className="max-w-4xl mx-auto text-center">
					{/* Main heading with animation */}
					<h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white text-shadow animate-fade-in-down">
						{t("heroTitle")}
					</h1>

					{/* Subtitle with animation */}
					<p className="text-white text-lg sm:text-xl mt-6 max-w-2xl mx-auto animate-fade-in-up animate-delay-200">
						{t("heroDescription")}
					</p>

					{/* Contact info cards */}
					<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10 max-w-2xl mx-auto animate-fade-in-up animate-delay-300">
						{contactItems.map((item, index) => (
							<div
								key={index}
								className="flex items-center gap-3 bg-white/10 backdrop-blur-md rounded-xl px-4 py-3 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105"
							>
								<item.icon className="text-accent text-xl flex-shrink-0" />
								<div className="text-left">
									<p className="text-white/70 text-xs">{item.label}</p>
									<p className="text-white font-medium text-sm">{item.value}</p>
								</div>
							</div>
						))}
					</div>

					{/* CTA Button */}
					<div className="mt-10 animate-fade-in-up animate-delay-500">
						<button
							onClick={handleContactClick}
							className="primary-btn text-lg px-10 py-4"
						>
							{t("heroButton")}
						</button>
					</div>
				</div>
			</div>

			{/* Bottom gradient fade */}
			<div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cream dark:from-slate-900 to-transparent"></div>
		</section>
	);
};

export default Hero;
